export class Edge {
  public static INTERACTION_DETECTION_METHOD: string = 'interaction_detection_method';
  public static MI_SCORE: string = 'mi_score';
  public static COLLAPSED_COLOR: string = 'collapsed_color';
  public static AFFECTED_BY_MUTATION: string = 'affected_by_mutation';
  public static SHAPE: string = 'shape';
  public static COLOR: string = 'color';
  public static ID: string = 'id';
  public static INTERACTION_AC: string = 'interaction_ac';
  public static NEGATIVE: string = 'negative';
}
